import { render, staticRenderFns } from "./addgoodticket.vue?vue&type=template&id=12960da8&"
import script from "./addgoodticket.vue?vue&type=script&lang=js&"
export * from "./addgoodticket.vue?vue&type=script&lang=js&"
import style0 from "./addgoodticket.vue?vue&type=style&index=0&id=12960da8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports